import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/lego.svg'


const _hoisted_1 = { class: "editor-container" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  alt: "慕课乐高",
  src: _imports_0,
  class: "inline-block h-8 w-8"
}, null, -1)
const _hoisted_5 = { class: "flex items-center gap-4" }
const _hoisted_6 = { class: "sidebar-container" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "画布区域", -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "该元素被锁定，无法编辑", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, "请先选择一个元素", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_arrow_left_outlined = _resolveComponent("arrow-left-outlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_edit = _resolveComponent("inline-edit")!
  const _component_user_profile = _resolveComponent("user-profile")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_a_layout = _resolveComponent("a-layout")!
  const _component_field_string_outlined = _resolveComponent("field-string-outlined")!
  const _component_components_list = _resolveComponent("components-list")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_file_image_outlined = _resolveComponent("file-image-outlined")!
  const _component_build_outlined = _resolveComponent("build-outlined")!
  const _component_l_shape = _resolveComponent("l-shape")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_history_area = _resolveComponent("history-area")!
  const _component_edit_wrapper = _resolveComponent("edit-wrapper")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_edit_group = _resolveComponent("edit-group")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_layer_list = _resolveComponent("layer-list")!
  const _component_props_table = _resolveComponent("props-table")!
  const _component_publish_form = _resolveComponent("publish-form")!
  const _component_preview_form = _resolveComponent("preview-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_layout, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_layout_header, { class: "flex-center" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_a_button, {
                shape: "circle",
                class: "mr-2",
                onClick: _ctx.goBack
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_arrow_left_outlined)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_router_link, { to: "/" }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }),
                _createVNode(_component_inline_edit, {
                  value: _ctx.page.title ?? '',
                  onChange: _ctx.titleChange
                }, null, 8, ["value", "onChange"])
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              (!_ctx.isCreatingMode)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    type: "primary",
                    shape: "round",
                    onClick: _ctx.preview
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 预览和设置 ")
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_a_button, {
                type: "primary",
                shape: "round",
                loading: _ctx.saveIsLoading,
                onClick: _ctx.handleSave
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 保存 ")
                ]),
                _: 1
              }, 8, ["loading", "onClick"]),
              (!_ctx.isCreatingMode)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    type: "primary",
                    shape: "round",
                    loading: _ctx.isPublishing,
                    onClick: _ctx.publish
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 发布 ")
                    ]),
                    _: 1
                  }, 8, ["loading", "onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_user_profile)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_layout, { class: "editor-content" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_layout_sider, {
          width: "300",
          style: {"background":"#fff"},
          class: "settings-panel"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_a_tabs, {
                activeKey: _ctx.activeCompTab,
                "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeCompTab) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_tab_pane, { key: "text" }, {
                    tab: _withCtx(() => [
                      _createElementVNode("span", null, [
                        _createVNode(_component_field_string_outlined),
                        _createTextVNode(" 文本 ")
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_components_list, {
                        list: _ctx.dynamicTemplates[_ctx.TemplateType.TEXT],
                        type: _ctx.TemplateType.TEXT,
                        onOnItemClick: _ctx.addItem
                      }, null, 8, ["list", "type", "onOnItemClick"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, { key: "image" }, {
                    tab: _withCtx(() => [
                      _createElementVNode("span", null, [
                        _createVNode(_component_file_image_outlined),
                        _createTextVNode(" 图片 ")
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_components_list, {
                        list: _ctx.dynamicTemplates[_ctx.TemplateType.IMAGE],
                        type: _ctx.TemplateType.IMAGE,
                        onOnItemClick: _ctx.addItem
                      }, null, 8, ["list", "type", "onOnItemClick"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_tab_pane, { key: "shape" }, {
                    tab: _withCtx(() => [
                      _createElementVNode("span", null, [
                        _createVNode(_component_build_outlined),
                        _createTextVNode(" 形状 ")
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_l_shape, {
                        background: "#eee",
                        width: "50px",
                        height: "50px"
                      }),
                      _createVNode(_component_components_list, {
                        list: _ctx.dynamicTemplates[_ctx.TemplateType.SHAPE],
                        type: _ctx.TemplateType.SHAPE,
                        onOnItemClick: _ctx.addItem
                      }, null, 8, ["list", "type", "onOnItemClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["activeKey"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_a_layout, { style: {"padding":"0 24px 24px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_a_layout_content, { class: "preview-container" }, {
              default: _withCtx(() => [
                _hoisted_7,
                _createVNode(_component_history_area),
                _createElementVNode("div", {
                  id: "canvas-area",
                  class: _normalizeClass(["preview-list", { 'canvas-fix': _ctx.canvasFix }])
                }, [
                  _createElementVNode("div", {
                    class: "body-container",
                    style: _normalizeStyle(_ctx.page.props)
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.components, (component) => {
                      return (_openBlock(), _createBlock(_component_edit_wrapper, {
                        id: component.id,
                        key: component.id,
                        hidden: component.isHidden,
                        props: component.props,
                        active: component.id === (_ctx.currentElement && _ctx.currentElement.id),
                        onSetActive: _ctx.setActive,
                        onUpdatePosition: _ctx.updatePosition
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(component.name), _normalizeProps(_guardReactiveProps(component.props)), null, 16))
                        ]),
                        _: 2
                      }, 1032, ["id", "hidden", "props", "active", "onSetActive", "onUpdatePosition"]))
                    }), 128))
                  ], 4)
                ], 2)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_a_layout_sider, {
          width: "300",
          style: {"background":"#fff"},
          class: "settings-panel"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tabs, {
              activeKey: _ctx.activeAttrTab,
              "onUpdate:activeKey": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.activeAttrTab) = $event)),
              type: "card"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_tab_pane, {
                  key: "component",
                  tab: "属性设置",
                  class: "no-top-radius"
                }, {
                  default: _withCtx(() => [
                    (_ctx.currentElement)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          (!_ctx.currentElement.isLocked)
                            ? (_openBlock(), _createBlock(_component_edit_group, {
                                key: 0,
                                props: (_ctx.currentElement.props as any),
                                onChange: _ctx.handleChange
                              }, null, 8, ["props", "onChange"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createVNode(_component_a_empty, null, {
                                  description: _withCtx(() => [
                                    _hoisted_10
                                  ]),
                                  _: 1
                                })
                              ]))
                        ]))
                      : (_openBlock(), _createBlock(_component_a_empty, { key: 1 }, {
                          description: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 1
                        }))
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_tab_pane, {
                  key: "layer",
                  tab: "图层设置"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_layer_list, {
                      list: _ctx.components,
                      "selected-id": (_ctx.currentElement?.id as string),
                      onChange: _ctx.handleChange,
                      onSelect: _ctx.setActive
                    }, null, 8, ["list", "selected-id", "onChange", "onSelect"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_tab_pane, {
                  key: "page",
                  tab: "页面设置"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_props_table, {
                      props: (_ctx.page.props as any),
                      onChange: _ctx.pageChange
                    }, null, 8, ["props", "onChange"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["activeKey"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_publish_form, {
      visible: _ctx.showPublishForm,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showPublishForm) = $event)),
      onPublishSuccess: _ctx.handlePublishSuccess
    }, null, 8, ["visible", "onPublishSuccess"]),
    (_ctx.showPreviewForm)
      ? (_openBlock(), _createBlock(_component_preview_form, {
          key: 0,
          visible: _ctx.showPreviewForm,
          "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showPreviewForm) = $event))
        }, null, 8, ["visible"]))
      : _createCommentVNode("", true)
  ]))
}